export class InvalidEikError extends Error {

    public constructor() {
        super('Invalid EIK');
        Object.setPrototypeOf(this, InvalidEikError.prototype);
    }

}
